import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Row } from "react-bootstrap";

import * as Template from "../../templates";
import * as actions from "../../actions";

import { useNavigate, useParams } from "react-router-dom";


export default (props) => {
  const moduleName = `reward_rules`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();
  const [name, setName] = useState(``);
  const [rate, setRate] = useState(``);
  const [min, setMin] = useState(``);
  const [max, setMax] = useState(``);
  const [submitted, setSubmitted] = useState(false);
  const [state, setState] = useState(``);

  const params = useParams()

  const navigate = useNavigate()

  
  const [id, setId] = useState();

  const handleChangeState = (value) => setState(value);

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.reward_rules_store != undefined && appReducer.reward_rules_store.error == false) ||
        (appReducer.reward_rules_update != undefined && appReducer.reward_rules_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.reward_rules_store,
    appReducer.reward_rules_update
  ])


  useEffect(() => {
    if (appReducer.reward_rules_edit != undefined && id != undefined) {
      let row = appReducer.reward_rules_edit.data;
      setName(row.name);
      setRate(row.rate);
      setMin(row.min);
      setMax(row.max);
      setState({
        value: row.state,
        label: row.state == `active` ? `فعال` : `غیرفعال`,
      });
    }
  }, [appReducer.reward_rules_edit]);

  useEffect(() => {
    dispatch(actions.list(`provinces/option`));
  }, []);


  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])


  return (
    <Row>
      <Template.Card col="col-md-6 col-xs-12 col-sm-12" title={props.page}>
        <Template.Form>
          <Template.Input
            required
            value={name}
            label="نام"
            name="name"
            type="text"
          />
          <Template.Input
            required
            value={min}
            label=" کمترین میزان خرید (تومان)   "
            name="min"
            type="text"
          />

          <Template.Input
            required
            value={max}
            label="بیشترین میزان خرید (تومان)" 
            name="max"
            type="text"
          />

          <Template.Input
            required
            value={rate}
            label="امتیاز"
            name="rate"
            type="text"
          />
          <Template.SingleSelect
            withLabel
            required
            placeholder="وضعیت"
            onChange={handleChangeState}
            name="state"
            value={state}
            options={[
              {
                value: "active",
                label: "فعال",
              },
              {
                value: "deactive",
                label: "غیرفعال",
              },
            ]}
          />
          <Template.Button
            label="ذخیره"
            
            onClick={handleClick}
          />
        </Template.Form>
      </Template.Card>
    </Row>
  );
};